(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["page-lp-content"]) return;
  try {
    
console.log("Promolayer manual trigger")
let isBlocked1 = true;
history.pushState({ page: 1 }, null, location.href);
window.addEventListener('popstate', (event) => {
  if (isBlocked1) {
    history.pushState({ page: 1 }, null, location.href);
    isBlocked1 = false;
    console.log("popstate triggered")
    promolayer.triggerDisplay('J4OmoWOd9AErFRxLIYaD');
    event.preventDefault();
  }
});


  } catch(e) { console.error(e); }
})();
})();
